import { I18n as I18n_ } from 'i18n-js';
import ja from './generate/ja';

export const I18n = new I18n_(ja, {
  locale: 'ja',
  defaultLocale: 'ja',
  availableLocales: ['ja'],
  enableFallback: true,
});
